// extracted by mini-css-extract-plugin
export default {"title":"GroupDate_title__h3MLO"};